// import React, { useState, ChangeEvent, FormEvent } from "react";
// import emailjs from "emailjs-com";
import InstagramLink from "./InstagramLink";
import TiktokLink from "./TiktokLink";

interface ContactProps {
  data?: {
    address: string;
    phone: string;
    email: string;
    instagram: string;
    instagram_link: string;
  };
}

// const initialState = {
//   name: "",
//   email: "",
//   message: "",
//   instagram: "",
//   instagram_link: "",
// };

export const Contact: React.FC<ContactProps> = (props) => {
  // const [{ name, email, message }, setState] = useState(initialState);

  // const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   const { name, value } = e.target;
  //   setState((prevState) => ({ ...prevState, [name]: value }));
  // };

  // const clearState = () => setState({ ...initialState });

  // const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   console.log(name, email, message);

  //   // Replace below with your own Service ID, Template ID and Public Key from your EmailJS account
  //   emailjs
  //     .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target as HTMLFormElement, "YOUR_PUBLIC_KEY")
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         clearState();
  //       },
  //       (error) => {
  //         console.log(error.text);
  //       }
  //     );
  // };

  return (
    <div id="contact">
      <div className="container">
        <div className="col-md-12">
          <div className="row">
            <div className="social">
              <ul>
                <li>
                  <InstagramLink iconColor="white" />
                </li>
                <li>
                  <TiktokLink iconColor="white" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};